'use client';

import { LoaderCircle } from 'lucide-react';
import { forwardRef } from 'react';
import { useFormState } from 'react-hook-form';

import { useIsNavigating } from '@/hooks/use-is-navigating';
import { cn } from '@/utils';

import { Button, type ButtonProps } from '../ui/button';

export interface ButtonSubmitNoFormProps extends ButtonProps {
  isSubmitting?: boolean;
}

const ButtonSubmitNoForm = forwardRef<HTMLButtonElement, ButtonSubmitNoFormProps>(
  ({ children, className, isSubmitting = false, disabled, ...props }, ref) => {
    const isNavigating = useIsNavigating();

    return (
      <Button
        variant="primary"
        size="primary"
        type="submit"
        className={cn('w-fit relative', isSubmitting && 'text-blue-400', className)}
        disabled={disabled || isSubmitting || isNavigating}
        {...props}
        ref={ref}
      >
        {children ?? 'Uložit'}
        {isSubmitting && (
          <div className="absolute inset-0 flex items-center justify-center">
            <LoaderCircle className="h-1/2 animate-spin text-white" />
          </div>
        )}
      </Button>
    );
  },
);
ButtonSubmitNoForm.displayName = 'ButtonSubmitNoForm';

const ButtonSubmit = forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    const { isSubmitting } = useFormState();
    return <ButtonSubmitNoForm ref={ref} {...props} isSubmitting={isSubmitting} />;
  },
);
ButtonSubmit.displayName = 'ButtonSubmit';
export { ButtonSubmit, ButtonSubmitNoForm };
